import { styled } from 'styled-components';

import { Image } from 'app/components/image';
import { breakpointTablet } from 'app/style/breakpoints';

export const StyledImage = styled(Image)`
    max-height: 77px;
    max-width: 100%;
    min-width: 0;
`;

export const StyledDefaultLogo = styled(Image)`
    max-width: 80px;

    @media (min-width: ${breakpointTablet}) {
        max-width: 120px;
    }
`;
